<template>
  <select ref="select" v-if="isMapMode" @change="onChange">
    <option v-for="(opt,idx) in items" :key=idx :value=opt[itemValue]>{{ opt[textValue] }}</option>
  </select>
  <select ref="select" v-else           @change="onChange">
    <option v-for="(opt,idx) in items" :key=idx :value=opt>{{ opt }}</option>
  </select>
</template>

<script>
const isDebug = true
export default {
  inheritAttrs: false,
  props: {
    value: [String, Number, Object, Array],
    items: Array,
    textValue: { type: String, default: "text" },
    itemValue: { type: String, default: "value" },
  },
  data () {
    return {
      items_cp : [],
      isMapMode : false
    }
  },
  watch : {
    item : { handler() { this.checkMapMode() }, deep: true },
    value : 'setValue',
  },
  created() {
    this.checkMapMode()
    // console.log("value type :", typeof this.value);
    // console.log("value value :", this.value);
    // console.log("items type :", typeof this.items);
    // console.log("items value :", this.items);
    // console.log("itemValue type :", typeof this.itemValue);
    // console.log("itemValue value :", this.itemValue);
  },
  mounted() {
    this.setValue()
  },
  methods: {
    checkMapMode() {
      const v = _.get(this.items, "[0]")
      if (_.isObject(v)) {
        this.isMapMode = true
      }
    },
    setValue() {
      this.$refs.select.value = this.value
    },
    onChange(v) {
      const value = v.target.value
      const item = this.items[v.target.selectedIndex]
      let v2 = null
      if (this.isMapMode) {
        v2 = item[this.itemValue]
      } else {
        v2 = item
      }
      // console.log("v type :", typeof v);
      // console.log("v type :", typeof v);
      // console.log("v value :", v);
      // console.log("value type :", typeof this.value);
      // console.log("value value :", this.value);
      // console.log("value type :", typeof value);
      // console.log("value value :", value);
      this.$emit("input", v2)
      // this.$emit("change", v2)
    }
  },
}
</script>
